<template>
  <div>

    <div class="box">
      <div class="flex justify-between">
        <p class="font-bold">Total Purchases/Sales</p>
        <div class="">
          <button
            type="button"
            class="btn text-xs"
            :class="selectedDateRange === 'current-month' ? 'btn-green' : 'bg-theme-200 light:bg-theme-600'"
            @click="selectDateRange('current-month')"
          >Current month</button>
          <button
            type="button"
            class="btn text-xs ml-1"
            :class="selectedDateRange === 'previous-month' ? 'btn-green' : 'bg-theme-200 light:bg-theme-600'"
            @click="selectDateRange('previous-month')"
          >Previous month</button>
          <button
            type="button"
            class="btn text-xs ml-1"
            :class="selectedDateRange === 'last-30-days' ? 'btn-green' : 'bg-theme-200 light:bg-theme-600'"
            @click="selectDateRange('last-30-days')"
          >Last 30 days</button>
        </div>
      </div>

      <product-totals-chart :productID="productID" :selectedDateRange="selectedDateRange"/>
    </div>

  </div>
</template>

<script>
const ProductTotalsChart = resolve => require(['@/components/pages/reports/ProductTotalsChart'], resolve)

export default {
  props: ['productID'],
  components: {
    ProductTotalsChart,
  },
  data() {
    return {
      selectedDateRange: 'current-month',
    }
  },
  mounted() {},
  methods: {
    selectDateRange(identifier) {
      if (this.selectedDateRange === identifier) {
        return
      }
      this.selectedDateRange = identifier
    },
  }
}
</script>

